/*
 * FunFungi · Escalera de descuentos con lo que ya hay en el carrito (17-10-2026, pedido de Mau).
 * Fuente única: metacampo de la tienda funfungi.escalera (JSON), que snippets/ff-colores.liquid imprime en
 * <script id="ff-escalera-datos">. De ahí salen también los descuentos automáticos de Shopify: si se cambia un
 * escalón, se cambia el metacampo y se vuelven a crear los descuentos con el mismo dato.
 *
 * Familias: «monto» (extractos: el escalón depende del total de lista de la familia en el carrito), «cantidad»
 * (café y té: depende de las unidades) o «unidad» (03-11, test 3x2 / 5x3: desde N frascos, `menos` pesos por frasco,
 * igual que los descuentos automáticos de monto fijo por artículo). Los regalos en $0 no cuentan.
 * Atajos (03-11): `datos.atajos` = packs que agregan frascos sueltos (assets/ff-atajos.js); aquí se cotizan como
 * esos frascos, al precio de lista de un frasco (`datos.lista_frasco`).
 *
 * API (window.FFEscalera):
 *   cotizar(productId, listaUnidad, cantidad) → { pct, pctAntes, total, lista, unidad, extra, ahorroCarrito }
 *     total = lo que cuestan esas unidades con el escalón que alcanza el carrito al sumarlas;
 *     extra = cuánto sube el total del carrito (incluye que lo que ya estaba también baja de escalón).
 *   familia(productId) · carrito() · alCambiar(fn) · actualizar() · minimosRegalos(productId, lista, regalos) · idDeHandle(handle)
 *   (también avisa con el evento «ff-escalera:carrito» cada vez que lee el carrito)
 * Además ajusta sola la escalera de Shrine en la ficha (quantity-breaks) cuando el carrito ya tiene
 * productos de la misma familia, y pone una nota arriba; y el precio de las tarjetas (.ff-precio-dinamico,
 * snippets/card-product.liquid) con «X % OFF con tu carrito», y los precios sueltos (.ff-precio-simple: botón del
 * final de los artículos, videos comprables) y las sugerencias del carrito de Kaching (.ffe-up).
 */
(function () {
  'use strict';
  if (window.FFEscalera) return;
  var nodo = document.getElementById('ff-escalera-datos');
  var datos = null;
  try { datos = JSON.parse(nodo && nodo.textContent || 'null'); } catch (e) { datos = null; }
  if (!datos || !datos.familias) return;

  var famDe = {};
  datos.familias.forEach(function (f) { f.productos.forEach(function (id) { famDe[String(id)] = f; }); });
  var atajos = datos.atajos || {};
  var listaFrasco = Number(datos.lista_frasco || 0);
  function atajo(id) { var a = atajos[String(id)]; return a && a.productos && a.productos.length && listaFrasco ? a : null; }
  // Frascos de regalo que suma cada opción de la ficha del pack (ff-atajos.js): dúo, 1 por agregado; Pack 4, 1 por pack.
  // Pack que siempre entra con su hongo de regalo (para decirlo en tarjetas y sugerencias).
  function conRegalo(id) { var a = atajo(id); return !!(a && a.regalo_siempre); }
  function regalosDe(a, q) { return a && a.regalo ? Number(a.regalo) * (a.regalo_por_pack ? q : 1) : 0; }

  var carrito = null, oyentes = [];
  function plata(n) { return '$' + Math.round(n).toLocaleString('es-CL'); }
  function pctPara(f, medida) {
    var p = 0;
    f.escalones.forEach(function (e) { if (medida >= e.desde && e.pct > p) p = e.pct; });
    return p;
  }
  // «unidad»: pesos menos por frasco con la medida (unidades) que alcanza la familia.
  function menosPara(f, medida) {
    var m = 0;
    f.escalones.forEach(function (e) { if (medida >= e.desde && (e.menos || 0) > m) m = e.menos; });
    return m;
  }
  // Valor de `unidades` (que valen `lista` a precio de lista) cuando la familia alcanza `medida`.
  function valorFam(f, medida, lista, unidades) {
    if (f.tipo === 'unidad') return Math.max(0, lista - unidades * menosPara(f, medida));
    return lista * (1 - pctPara(f, medida) / 100);
  }
  // Porcentaje para mostrar («33 % OFF»).
  function pctMostrar(f, medida, listaUnidad) {
    if (f.tipo === 'unidad') return listaUnidad ? Math.round(menosPara(f, medida) / listaUnidad * 100) : 0;
    return pctPara(f, medida);
  }
  // Medida de la familia en el carrito (monto de lista o unidades) y su total de lista, sin regalos en $0.
  function enCarrito(f) {
    var medida = 0, lista = 0;
    ((carrito && carrito.items) || []).forEach(function (it) {
      if (famDe[String(it.product_id)] !== f) return;
      if (it.final_line_price === 0) return;
      var unidad = (it.original_price || it.price) / 100;
      lista += unidad * it.quantity;
      medida += f.tipo === 'monto' ? unidad * it.quantity : it.quantity;
    });
    return { medida: medida, lista: lista };
  }
  function cotizar(productId, listaUnidad, cantidad) {
    cantidad = cantidad || 1;
    // Pack como atajo: se cotiza como sus frascos sueltos (un pack de 4 = 4 frascos).
    var a = atajo(productId);
    if (a) {
      // El Pack 4 (`regalo_siempre`) entra siempre con su hongo de regalo: también se cotiza con él.
      var r = cotizar(a.productos[0], listaFrasco, cantidad * a.productos.length + (a.regalo_siempre ? regalosDe(a, cantidad) : 0));
      r.atajo = true;
      return r;
    }
    var f = famDe[String(productId)];
    var lista = listaUnidad * cantidad;
    if (!f) return { pct: 0, pctAntes: 0, total: lista, lista: lista, unidad: listaUnidad, extra: lista, ahorroCarrito: 0, familia: null };
    var ya = enCarrito(f);
    var suma = f.tipo === 'monto' ? listaUnidad * cantidad : cantidad;
    var m0 = ya.medida, m1 = ya.medida + suma;
    var unidadesYa = f.tipo === 'monto' ? 0 : ya.medida;
    var total = Math.round(valorFam(f, m1, lista, cantidad));
    var antes = Math.round(valorFam(f, m0, ya.lista, unidadesYa));
    var ahoraYa = Math.round(valorFam(f, m1, ya.lista, unidadesYa));
    return {
      pct: pctMostrar(f, m1, listaUnidad), pctAntes: pctMostrar(f, m0, listaUnidad), total: total, lista: lista,
      unidad: Math.round(total / cantidad), extra: ahoraYa + total - antes, ahorroCarrito: Math.max(0, antes - ahoraYa),
      familia: f, yaEnCarrito: ya.medida > 0
    };
  }

  // Varios productos a la vez (p. ej. «Agrégalos a tu carrito»): items = [{ id, lista, cantidad }].
  // Devuelve el total de cada uno y del conjunto con el escalón que alcanzan juntos más lo que ya hay en el carrito.
  function cotizarVarios(items) {
    var lineas = simular(null, 0, 0);
    var antes = lineas.reduce(function (a, l) { return a + l.valor; }, 0);
    // Un pack-atajo se cotiza como sus frascos; `orig` junta de nuevo sus frascos en la fila del pack.
    var nuevas = [];
    items.forEach(function (it, n) {
      var a = atajo(it.id);
      if (a) {
        a.productos.forEach(function (p) { nuevas.push({ id: String(p), qty: it.cantidad || 1, unidad: listaFrasco, orig: n }); });
        if (a.regalo_siempre) nuevas.push({ id: String(a.productos[0]), qty: regalosDe(a, it.cantidad || 1), unidad: listaFrasco, orig: n });
      }
      else nuevas.push({ id: String(it.id), qty: it.cantidad || 1, unidad: it.lista, orig: n });
    });
    var todas = lineas.map(function (l) { return { id: l.id, qty: l.qty, unidad: l.unidad }; }).concat(nuevas);
    var res = items.map(function () { return { total: 0, lista: 0, pct: 0 }; });
    var medida = {};
    todas.forEach(function (l) { var f = famDe[l.id]; if (f) medida[f.id] = (medida[f.id] || 0) + (f.tipo === 'monto' ? l.unidad * l.qty : l.qty); });
    var despues = 0;
    todas.forEach(function (l, i) {
      var f = famDe[l.id], pct = f ? pctMostrar(f, medida[f.id], l.unidad) : 0, v = Math.round(f ? valorFam(f, medida[f.id], l.unidad * l.qty, l.qty) : l.unidad * l.qty);
      despues += v;
      if (i >= lineas.length) { var r = res[l.orig]; r.total += v; r.lista += l.unidad * l.qty; r.pct = Math.max(r.pct, pct); }
    });
    return { items: res, total: res.reduce(function (a, r) { return a + r.total; }, 0), lista: res.reduce(function (a, r) { return a + r.lista; }, 0), extra: despues - Math.round(antes) };
  }

  function avisar() {
    oyentes.forEach(function (fn) { try { fn(carrito); } catch (e) {} });
    try { document.dispatchEvent(new CustomEvent('ff-escalera:carrito', { detail: carrito })); } catch (e) {}
  }
  var leyendo = null;
  function actualizar() {
    if (leyendo) return leyendo;
    leyendo = fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { carrito = c; leyendo = null; avisar(); return c; })
      .catch(function () { leyendo = null; });
    return leyendo;
  }
  var espera = null;
  function pronto() { clearTimeout(espera); espera = setTimeout(actualizar, 250); }

  // Cualquier cambio del carrito (tema, Kaching, quiz…) pasa por /cart/*.js: se vuelve a leer después.
  var fetchOriginal = window.fetch;
  window.fetch = function (url) {
    var p = fetchOriginal.apply(this, arguments);
    try {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(pronto, pronto);
    } catch (e) {}
    return p;
  };
  ['cart:refresh', 'kaching-cart:cart-updated', 'kaching-cart:item-added', 'kaching-cart:item-removed'].forEach(function (ev) {
    document.addEventListener(ev, pronto);
  });

  // --- Regalos: cuántas unidades de este producto faltan para cada regalo, con lo que ya hay en el carrito ---
  // Las reglas son las de Kaching Cart (reglas de regalo y barra de premios), leídas del script que Kaching pone en
  // la página. Si no están (tema publicado sin Kaching Cart, o Kaching cambió su formato), devuelve null y el
  // bloque de regalos usa los números fijos de su configuración.
  var kc = null;
  function objetoDesde(texto, desde) {
    var i = texto.indexOf('{', desde), prof = 0, enTexto = false;
    if (i < 0) return null;
    for (var k = i; k < texto.length; k++) {
      var ch = texto[k];
      if (enTexto) { if (ch === '\\') k++; else if (ch === '"') enTexto = false; continue; }
      if (ch === '"') enTexto = true;
      else if (ch === '{') prof++;
      else if (ch === '}' && --prof === 0) { try { return JSON.parse(texto.slice(i, k + 1)); } catch (e) { return null; } }
    }
    return null;
  }
  function configKaching() {
    if (kc !== null) return kc;
    kc = false;
    var scripts = document.querySelectorAll('script:not([src])');
    for (var n = 0; n < scripts.length; n++) {
      var t = scripts[n].textContent || '';
      var i = t.indexOf('autoAtcRules: {');
      if (i < 0) continue;
      var reglas = objetoDesde(t, i);
      var j = t.indexOf('"tieredPromotionsBar":{');
      var barra = j > -1 ? objetoDesde(t, j + 22) : null;
      kc = { reglas: (reglas && reglas.rules || []).filter(function (r) { return r.isEnabled; }), barra: barra && barra.isActive ? barra : null };
      break;
    }
    return kc;
  }
  function idNum(x) { return String(x || '').replace(/\D/g, ''); }
  // El carrito como quedaría al sumar «q» unidades del producto: líneas con su valor ya con la escalera
  // (como lo verá Kaching después del cambio a descuentos automáticos). Sin las líneas de regalo en $0.
  function simular(pid, unidad, q) {
    var lineas = ((carrito && carrito.items) || []).filter(function (it) { return it.final_line_price !== 0; }).map(function (it) {
      return { id: String(it.product_id), qty: it.quantity, unidad: (it.original_price || it.price) / 100 };
    });
    if (q > 0) {
      var a = atajo(pid);
      if (a) {
        a.productos.forEach(function (p) { lineas.push({ id: String(p), qty: q, unidad: listaFrasco }); });
        // Dúo con hongo de regalo: cada opción de su ficha suma ese frasco (ff-atajos.js), así que también cuenta aquí.
        if (a.regalo) lineas.push({ id: String(a.productos[0]), qty: regalosDe(a, q), unidad: listaFrasco });
      }
      else lineas.push({ id: String(pid), qty: q, unidad: unidad });
    }
    var medida = {};
    lineas.forEach(function (l) { var f = famDe[l.id]; if (f) medida[f.id] = (medida[f.id] || 0) + (f.tipo === 'monto' ? l.unidad * l.qty : l.qty); });
    lineas.forEach(function (l) { var f = famDe[l.id]; l.valor = f ? valorFam(f, medida[f.id], l.unidad * l.qty, l.qty) : l.unidad * l.qty; });
    return lineas;
  }
  // true / false, o null si la regla usa algo que aquí no se sabe evaluar.
  function cumpleRegla(r, lineas) {
    var res = r.triggers.map(function (t) {
      if (t.conditionType !== 'product') return null;
      var ids = (t.values || []).map(function (v) { return idNum(v && v.productId); });
      var de = lineas.filter(function (l) { return ids.indexOf(l.id) > -1; });
      if (t.thresholdType === 'total_quantity') return de.reduce(function (a, l) { return a + l.qty; }, 0) >= t.threshold;
      if (t.thresholdType === 'total_value') return de.reduce(function (a, l) { return a + l.valor; }, 0) >= t.threshold;
      return null;
    });
    if (res.indexOf(null) > -1 || !res.length) return null;
    return r.triggerMatchMode === 'any' ? res.indexOf(true) > -1 : res.indexOf(false) < 0;
  }
  function cumpleTramo(barra, tramo, lineas) {
    var fuera = (barra.excludedProductIds || []).concat(barra.productsExcludedFromUnlockCount || []).map(idNum);
    var de = lineas.filter(function (l) { return fuera.indexOf(l.id) < 0; });
    if (barra.thresholdType === 'cart-total') return de.reduce(function (a, l) { return a + l.valor; }, 0) >= tramo.threshold;
    if (barra.thresholdType === 'item-quantity') return de.reduce(function (a, l) { return a + l.qty; }, 0) >= tramo.threshold;
    return null;
  }
  // regalos: [{ producto: id del producto de regalo, visual: true si es un cuadro como «Envío gratis», nombre }]
  // Devuelve, para cada regalo, la cantidad mínima de este producto que lo entrega (1 si el carrito ya lo da),
  // o null si no hay regla que lo explique. Varios regalos del mismo producto se reparten las reglas en orden.
  function minimosRegalos(pid, unidad, regalos) {
    var c = configKaching();
    if (!c || !carrito) return null;
    var condiciones = {};
    function clave(g) { return g.visual ? 'envio' : idNum(g.producto); }
    c.reglas.forEach(function (r) {
      ((r.action && r.action.items) || []).forEach(function (a) {
        var k = idNum(a.productId); (condiciones[k] = condiciones[k] || []).push(function (l) { return cumpleRegla(r, l); });
      });
    });
    if (c.barra) (c.barra.tiers || []).forEach(function (t) {
      var ks = t.type === 'shipping-discount' ? ['envio'] : (t.targets || []).map(function (x) { return idNum(x.productId); });
      ks.forEach(function (k) { (condiciones[k] = condiciones[k] || []).push(function (l) { return cumpleTramo(c.barra, t, l); }); });
    });
    var usados = {};
    var mins = {};
    Object.keys(condiciones).forEach(function (k) {
      mins[k] = condiciones[k].map(function (cumple) {
        for (var q = 1; q <= 60; q++) { var r = cumple(simular(pid, unidad, q)); if (r === null) return null; if (r) return q; }
        return null;
      }).filter(function (m) { return m !== null; }).sort(function (a, b) { return a - b; });
    });
    return regalos.map(function (g) {
      if (g.visual && !/env[ií]o/i.test(g.nombre || '')) return null;
      var k = clave(g), lista = mins[k] || [];
      var n = usados[k] || 0; usados[k] = n + 1;
      return n < lista.length ? lista[n] : null;
    });
  }

  // Id del producto desde su handle (/products/<handle>.js), guardado en la sesión: el quiz y «Agrégalos a tu
  // carrito» conocen el producto por su enlace, no por su id.
  var ids = {};
  function idDeHandle(handle) {
    if (ids[handle]) return ids[handle];
    try { var g = sessionStorage.getItem('ffe:id:' + handle); if (g) return (ids[handle] = Promise.resolve(g)); } catch (e) {}
    ids[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { var id = d && d.id ? String(d.id) : null; try { if (id) sessionStorage.setItem('ffe:id:' + handle, id); } catch (e) {} return id; })
      .catch(function () { return null; });
    return ids[handle];
  }

  window.FFEscalera = {
    cotizar: cotizar,
    // Un pack-atajo es de la familia de sus frascos (así «Agrégalos», el test y la landing lo cotizan como frascos).
    familia: function (id) { var a = atajo(id); return famDe[String(id)] || (a ? famDe[String(a.productos[0])] || null : null); },
    atajo: function (id) { return atajo(id); },
    carrito: function () { return carrito; },
    alCambiar: function (fn) { oyentes.push(fn); if (carrito) fn(carrito); },
    actualizar: actualizar,
    plata: plata,
    minimosRegalos: minimosRegalos,
    productoFicha: function () { return productoFicha(); },
    idDeHandle: idDeHandle,
    cotizarVarios: cotizarVarios
  };

  // --- Ficha: escalera de Shrine con lo que ya hay en el carrito ---
  // El producto de la escalera: el del formulario de compra al que pertenece (en el editor de temas no hay
  // ShopifyAnalytics y el primer formulario de la página puede ser otro).
  function productoFicha() {
    var qb = document.querySelector('quantity-breaks');
    if (qb) {
      var x = qb.querySelector('input[form]');
      var f = qb.closest('form') || (x && document.getElementById(x.getAttribute('form')));
      var j = f && f.querySelector('input[name="product-id"]');
      if (j && j.value) return j.value;
    }
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (m && m.id) return m.id;
    var i = document.querySelector('form[action*="/cart/add"] input[name="product-id"]');
    return i ? i.value : null;
  }
  var originales = new WeakMap();
  function guardar(el) { if (el && !originales.has(el)) originales.set(el, el.innerHTML); }
  function restaurar(el) { if (el && originales.has(el) && el.innerHTML !== originales.get(el)) el.innerHTML = originales.get(el); }

  function pintarFicha() {
    var qb = document.querySelector('quantity-breaks');
    var pid = productoFicha();
    var esAtajo = !!(pid && atajo(pid));
    if (!qb || !pid || (!famDe[String(pid)] && !esAtajo)) return;
    var base = Number(qb.dataset.basePrice || 0) / 100;
    if (!base) return;
    // «unidad» y atajos: siempre el precio exacto (el de Shrine sale de % y no calza con el monto fijo por frasco).
    var siempre = esAtajo || famDe[String(pid)].tipo === 'unidad';
    // Dúo con hongo de regalo (`regalo` en el atajo): cada opción suma ese frasco elegido (dúo + 1 = 3x2; 2 dúos + 1 = 5x3).
    var aFicha = esAtajo ? atajo(pid) : null;
    var regalo = aFicha && aFicha.regalo ? Number(aFicha.regalo) : 0;
    var nota = qb.querySelector('.ffe-nota');
    var algunCambio = false, conCarrito = false;
    qb.querySelectorAll('label.quantity-break').forEach(function (l) {
      var q = Number(l.dataset.quantity || 1);
      // «c/u» de la bajada: siempre por frasco (en un pack, sus frascos; en el dúo, más el de regalo).
      var frascosOpcion = aFicha ? q * aFicha.productos.length + regalosDe(aFicha, q) : q;
      var c = regalo ? cotizar(aFicha.productos[0], listaFrasco, frascosOpcion) : cotizar(pid, base, q);
      var precio = l.querySelector('.quantity-break__price');
      var tachado = l.querySelector('.quantity-break__compare-price');
      var beneficio = l.querySelector('.quantity-break__benefit');
      var leyenda = l.querySelector('.quantity-break__caption');
      [precio, tachado, beneficio, leyenda].forEach(guardar);
      // «Tu carrito sube solo $X»: solo si el carrito ya trae de la misma familia y lo que ya estaba baja de escalón
      // (si no, sube lo mismo que el precio de la opción y la línea sobra).
      var sube = l.querySelector('.ffe-sube');
      var conSube = c.yaEnCarrito && c.pct > c.pctAntes && c.extra < c.total;
      if (!conSube && sube) sube.remove();
      if (!c.yaEnCarrito && !siempre) { [precio, tachado, beneficio, leyenda].forEach(restaurar); return; }
      if (c.yaEnCarrito) conCarrito = true;
      if (conSube) {
        var izq = l.querySelector('.quantity-break__left');
        if (izq && !sube) { sube = document.createElement('span'); sube.className = 'ffe-sube'; izq.insertBefore(sube, izq.querySelector('.ffrg-qb')); }
        var ts = 'Tu carrito sube solo ' + plata(c.extra);
        if (c.extra <= 0) ts = '¡Gratis con lo que ya tienes en tu carrito!';
      if (sube && sube.textContent !== ts) sube.textContent = ts;
      }
      algunCambio = true;
      if (precio) { var hp = '<strong>' + plata(c.total) + '</strong>'; if (precio.innerHTML !== hp) precio.innerHTML = hp; }
      if (tachado) { var ht = c.pct > 0 ? plata(c.lista) : ''; if (tachado.innerHTML !== ht) tachado.innerHTML = ht; tachado.classList.toggle('hidden', c.pct <= 0); }
      if (beneficio && originales.get(beneficio) && /\d+\s*%/.test(originales.get(beneficio))) {
        var hb = originales.get(beneficio).replace(/\d+(\s*%)/, c.pct + '$1'); if (beneficio.innerHTML !== hb) beneficio.innerHTML = hb;
      }
      if (leyenda && originales.get(leyenda) && /\$\s?[\d.]+/.test(originales.get(leyenda))) {
        var hl = originales.get(leyenda).replace(/\$\s?[\d.]+/, plata(c.total / frascosOpcion)); if (leyenda.innerHTML !== hl) leyenda.innerHTML = hl;
      }
    });
    if (algunCambio && conCarrito) {
      if (!nota) {
        nota = document.createElement('p');
        nota.className = 'ffe-nota';
        nota.style.cssText = 'margin:0 0 8px;font-size:12.5px;line-height:1.35;text-align:center;color:var(--ffp-pag-tono,#2B2622);font-weight:600';
        var titulo = qb.querySelector('.quantity-breaks__title');
        qb.insertBefore(nota, titulo ? titulo.nextSibling : qb.firstChild);
      }
      if (nota.textContent !== 'Precios con lo que ya tienes en tu carrito') nota.textContent = 'Precios con lo que ya tienes en tu carrito';
    } else if (nota) {
      nota.remove();
    }
  }
  // --- Tarjetas (colecciones, destacados, relacionados): precio de agregar 1 con lo que ya hay en el carrito ---
  function pintarTarjetas() {
    document.querySelectorAll('.ff-precio-dinamico[data-ff-producto]').forEach(function (caja) {
      var id = caja.dataset.ffProducto, lista = Number(caja.dataset.ffLista || 0) / 100;
      if ((!famDe[String(id)] && !atajo(id)) || !lista) return;
      guardar(caja);
      var c = cotizar(id, lista, 1);
      // Con descuento aunque el carrito esté vacío si el producto solo ya lo alcanza (Pack 4, dúos).
      // Un pack siempre con el precio de sus frascos (el de la variante en Shopify puede no calzar).
      if (c.pct <= 0 && !c.atajo) { restaurar(caja); return; }
      var html = c.pct <= 0
        ? '<div class="price ffe-precio"><div class="price__container"><div class="price__regular"><span class="price-item price-item--regular">' + plata(c.total) + '</span></div></div></div>'
        : '<div class="price price--on-sale ffe-precio"><div class="price__container"><div class="price__sale">' +
          '<span class="price-item price-item--sale price-item--last">' + plata(c.total) + '</span> ' +
          '<s class="price-item price-item--regular">' + plata(c.lista) + '</s></div></div></div>' +
          '<p class="ffe-tag">' + (conRegalo(id) ? '+1 de regalo · ' : '') + c.pct + '% OFF' + (c.yaEnCarrito ? ' con tu carrito' : '') + '</p>';
      if (caja.innerHTML !== html) caja.innerHTML = html;
    });
  }
  // Precios sueltos dentro de un texto (botón del final de los artículos, videos comprables): «$15.192 $18.990».
  function pintarSimples() {
    document.querySelectorAll('.ff-precio-simple[data-ff-producto]').forEach(function (el) {
      var id = el.dataset.ffProducto, lista = Number(el.dataset.ffLista || 0) / 100;
      if ((!famDe[String(id)] && !atajo(id)) || !lista) return;
      guardar(el);
      var c = cotizar(id, lista, 1);
      if (c.pct <= 0 && !c.atajo) { restaurar(el); return; }
      var html = plata(c.total) + (c.pct > 0 ? ' <s class="ffe-s">' + plata(c.lista) + '</s>' : '');
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }
  // Sugerencias del carrito de Kaching (abajo y lateral): precio de agregar 1 con lo que ya hay en el carrito.
  // No se toca el precio de Kaching (lo redibuja él): se oculta y al lado va el nuestro. Su texto es el precio de
  // lista, porque las sugerencias van sin descuento propio.
  function pintarUpsell() {
    document.querySelectorAll('.kaching-product-upsell-item[data-product-id], .kaching-side-upsell-item[data-product-id]').forEach(function (item) {
      var id = item.dataset.productId;
      var caja = item.querySelector('[class$="__price-container"]');
      var suyo = caja && caja.querySelector('[class$="__price-final"]');
      if (!suyo || (!famDe[String(id)] && !atajo(id))) return;
      var lista = Number((suyo.textContent || '').replace(/\D/g, ''));
      var mio = caja.querySelector('.ffe-up');
      var c = lista ? cotizar(id, lista, 1) : null;
      // Sin descuento ni nada que decir (1.er frasco con el carrito vacío): queda el precio de Kaching.
      if (!c || (c.pct <= 0 && !c.atajo && !(c.yaEnCarrito && c.extra < c.lista))) { if (mio) mio.remove(); if (suyo.style.display) suyo.style.display = ''; return; }
      // 03-11 (Mau: «que en Kaching vean el descuento: agrega este frasco por tanto, si ya alcanza el siguiente
      // escalón»): con productos de la misma familia en el carrito, el precio grande es lo que sube el carrito de
      // verdad (incluye lo que baja lo que ya llevaba) y se tacha el precio de lista de lo que se agrega.
      var html;
      if (c.yaEnCarrito) {
        var sube = Math.max(0, c.extra);
        var salta = c.pct > c.pctAntes;
        var esFrasco = c.familia && c.familia.tipo === 'unidad';
        var tag2 = sube <= 0 ? (salta && esFrasco ? '¡Va de regalo: completas el ' + (c.pct >= 40 ? '5x3' : '3x2') + '!' : '¡Va de regalo con tu carrito!')
          : salta ? (esFrasco ? (c.pct >= 40 ? '¡Completas el 5x3!' : '¡Completas el 3x2!') : 'Tu carrito pasa a ' + c.pct + '% OFF')
          : 'Precio con lo que ya llevas';
        html = '<span class="ffe-up__precio">' + (sube <= 0 ? 'Gratis' : plata(sube)) + '</span>' +
          (sube < c.lista ? '<s class="ffe-s">' + plata(c.lista) + '</s>' : '') + '<span class="ffe-up__tag">' + tag2 + '</span>';
      } else {
        html = c.pct <= 0 ? '<span class="ffe-up__precio">' + plata(c.total) + '</span>'
          : '<span class="ffe-up__precio">' + plata(c.total) + '</span><s class="ffe-s">' + plata(c.lista) + '</s><span class="ffe-up__tag">' +
            (conRegalo(id) ? '+1 de regalo · ' : '') + c.pct + '% OFF</span>';
      }
      if (!mio) { mio = document.createElement('span'); mio.className = 'ffe-up'; caja.appendChild(mio); }
      if (mio.innerHTML !== html) mio.innerHTML = html;
      if (suyo.style.display !== 'none') suyo.style.display = 'none';
    });
  }
  if (!document.getElementById('ffe-css')) {
    var st = document.createElement('style');
    st.id = 'ffe-css';
    st.textContent = '.ffe-tag{margin:2px 0 0;font-size:1.15rem;font-weight:700;line-height:1.2;color:var(--ffp-tono, #2A9B7A)}.ffe-s{opacity:.65;font-weight:400}' +
      '.ffe-up{display:flex;flex-wrap:wrap;align-items:baseline;gap:0 6px}.ffe-up__precio{font-weight:700}' +
      '.ffe-up__tag{flex-basis:100%;margin-top:1px;font-size:11.5px;font-weight:700;line-height:1.25;color:#2A9B7A}' +
      '.kaching-side-upsell-item .ffe-up{justify-content:center;text-align:center;padding:0 8px}' +
      // «Pagas 2» y «33% off» en una sola línea (en celular la pastilla se partía en «Paga / s 2»).
      'quantity-breaks .quantity-break__benefit{white-space:nowrap;flex-shrink:0}' +
      '.ffe-sube{display:block;margin-top:2px;font-size:12px;font-weight:700;line-height:1.25;color:var(--ffp-pag-tono,#2A9B7A)}';
    document.head.appendChild(st);
  }

  window.FFEscalera.alCambiar(pintarFicha);
  window.FFEscalera.alCambiar(pintarTarjetas);
  window.FFEscalera.alCambiar(pintarSimples);
  window.FFEscalera.alCambiar(pintarUpsell);
  // Tarjetas que aparecen después (carruseles, filtros, «cargar más»): se repintan solas.
  var esperaTarjetas = null;
  new MutationObserver(function () { clearTimeout(esperaTarjetas); esperaTarjetas = setTimeout(function () { if (carrito) { pintarTarjetas(); pintarSimples(); pintarUpsell(); } }, 200); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', actualizar);
  else actualizar();
})();
